namespace RioERP.Orders {
    export namespace BrandAmbassadorPaymentsService {
        export const baseUrl = 'Orders/BrandAmbassadorPayments';

        export declare function Create(request: Serenity.SaveRequest<BrandAmbassadorPaymentsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<BrandAmbassadorPaymentsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<BrandAmbassadorPaymentsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<BrandAmbassadorPaymentsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetBrandAmbassadorTotalShare(request: FranchiseePayoutRequest, onSuccess?: (response: FranchiseePayoutResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/BrandAmbassadorPayments/Create",
            Update = "Orders/BrandAmbassadorPayments/Update",
            Delete = "Orders/BrandAmbassadorPayments/Delete",
            Retrieve = "Orders/BrandAmbassadorPayments/Retrieve",
            List = "Orders/BrandAmbassadorPayments/List",
            GetBrandAmbassadorTotalShare = "Orders/BrandAmbassadorPayments/GetBrandAmbassadorTotalShare"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetBrandAmbassadorTotalShare'
        ].forEach(x => {
            (<any>BrandAmbassadorPaymentsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
